import $api from "@/common/api";
import $moment from "moment";
const infosignal = {
  namespaced: true,
  state: {
    // 激活tab菜单
    openTabMenuList:[
      // 角色管理
      {
        path: "/admin/pageMaintenance",
        name: "pageMaintenance",
        component: () => import("@/views/admin/adminOperation/pageMaintenance/index.vue"),
        meta:{
          name: '页面维护',
          keepAlive: true,
          activeMenu: 'operation',
          hidden: false,
        }
      },
    ],
    activeTabMenu:{
      path: "/admin/pageMaintenance",
      name: "pageMaintenance",
      component: () => import("@/views/admin/adminOperation/pageMaintenance/index.vue"),
      meta:{
        name: '页面维护',
        keepAlive: true,
        activeMenu: 'operation',
        hidden: false,
      }
    },
  },
  mutations: {
    // 存储激活菜单列表
    saveopenMenuList(state, payload){
      // state.openTabMenuList = payload;
      // for (var i = 0; i < state.openTabMenuList.length - 1; i++) {
      //   for (var j = i + 1; j < state.openTabMenuList.length; j++) {
      //     if (state.openTabMenuList[i].name == state.openTabMenuList[j].name) {
      //       state.openTabMenuList.splice(j, 1);
      //       //因为数组长度减小1，所以直接 j++ 会漏掉一个元素，所以要 j--
      //       j--;
      //     }
      //   }
      // }
        // return arr;
    },
    // 存储激活菜单项
    saveopenactiveMenu(state, payload){
      state.activeTabMenu = payload;
    },
  },
  actions: {

  },
  getters: {

  },
}
export default infosignal;